"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableLayoutConfigurationsList = exports.getBrandSpecificProductTableConfigurations = void 0;
var _bwmTableLayoutConfigurations = require("./bwm/bwmTableLayoutConfigurations");
var _cbaTableLayoutConfigurations = require("./cba/cbaTableLayoutConfigurations");
var _defaultTableLayoutConfigurations = require("./default/defaultTableLayoutConfigurations");
var _medibankTableLayoutConfigurations = require("./medibank/medibankTableLayoutConfigurations");
var _piaTableLayoutConfigurations = require("./pia/piaTableLayoutConfigurations");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var tableLayoutConfigurationsList = exports.tableLayoutConfigurationsList = {
  'bwm': _bwmTableLayoutConfigurations.bwmTableLayoutConfiguration,
  'cba': _cbaTableLayoutConfigurations.cbaTableLayoutConfiguration,
  'default': _defaultTableLayoutConfigurations.defaultTableLayoutConfiguration,
  'medibank': _medibankTableLayoutConfigurations.medibankTableLayoutConfiguration,
  'pia': _piaTableLayoutConfigurations.piaTableLayoutConfiguration
};

/**
 *
 * Returns the brand-specific product table layout configuration based on the
 * given brand name.
 */
var getBrandSpecificProductTableConfigurations = exports.getBrandSpecificProductTableConfigurations = function getBrandSpecificProductTableConfigurations(_ref) {
  var _ref$brand = _ref.brand,
    brand = _ref$brand === void 0 ? 'default' : _ref$brand;
  switch (brand) {
    case 'bwm':
      return _objectSpread({}, _bwmTableLayoutConfigurations.bwmTableLayoutConfiguration);
    case 'cba':
      return _objectSpread({}, _cbaTableLayoutConfigurations.cbaTableLayoutConfiguration);
    case 'medibank':
      return _objectSpread({}, _medibankTableLayoutConfigurations.medibankTableLayoutConfiguration);
    case 'pia':
      return _objectSpread({}, _piaTableLayoutConfigurations.piaTableLayoutConfiguration);
    default:
      return _objectSpread({}, _defaultTableLayoutConfigurations.defaultTableLayoutConfiguration);
  }
};